import script from "./EventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=3a85ed9d&scoped=true&lang=css"
import "./EventCard.vue?vue&type=style&index=1&id=3a85ed9d&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a85ed9d"]])

export default __exports__